import React from 'react';
import { motion } from 'framer-motion';
import { PhoneOff, Clock, UserX } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <PhoneOff className="w-8 h-8 text-brand-accent" data-id="element-130" />,
    title: 'Anrufe gehen ins Leere',
    description: 'Kunden erreichen Sie nicht — und rufen beim Wettbewerb an.'
  }, {
    icon: <Clock className="w-8 h-8 text-brand-accent" data-id="element-131" />,
    title: 'Kein Überblick über Anrufe',
    description: 'Wer hat angerufen? Was war das Anliegen? Niemand weiß es.'
  }, {
    icon: <UserX className="w-8 h-8 text-brand-accent" data-id="element-132" />,
    title: 'Kein Sekretariat, kein Budget',
    description: 'Eine Vollzeitkraft nur fürs Telefon? Für KMU nicht wirtschaftlich.'
  }];
  return <section className="py-20 bg-white" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-136">
            Wie viele Anrufe haben Sie heute verpasst?
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-137">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-gray rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-138">
              <div className="w-16 h-16 bg-brand-light rounded-xl flex items-center justify-center mb-6" data-id="element-139">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-140">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-141">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}